import { render, staticRenderFns } from "./WorkshopTambah.vue?vue&type=template&id=476bd2ec&scoped=true&"
import script from "./WorkshopTambah.vue?vue&type=script&lang=js&"
export * from "./WorkshopTambah.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopTambah.vue?vue&type=style&index=0&id=476bd2ec&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476bd2ec",
  null
  
)

export default component.exports